export default __webpack_public_path__ + "static/media/element.37064324.svg";